module.exports = __webpack_public_path__ + "static/media/icons.962a1bf3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.svg
// module id = 406
// module chunks = 0